import { axiosRequest } from "../../configs/axios.config";

export class EnterpriseService {
  updateRequestType(enterprise_id, data) {
    axiosRequest
      .patch(`/enterprises/${enterprise_id}/update_request_type`, data)
      .then(({ data }) => success(data))
      .catch(({ errorResp }) => error(errorResp));
  }
}
